import qinit = require('../qinit');

// Avoid `/block-pages/v3` prefix matching `/block-pages/v30`.
export const getRemoteBlockerBaseUrl = (): string => {
  try {
    const url = new URL(qinit.tenant.common.block_pages.block_url);
    const pathname = url.pathname.endsWith('/')
      ? url.pathname
      : `${url.pathname}/`;
    return `${url.origin}${pathname}`;
  } catch {
    return '';
  }
};
